module.exports = __webpack_public_path__ + "img/Bug Tracker.b4ef0d9c.svg";